<style>
    .ui-table-scrollable-header-box {
        margin: auto !important;
    }
</style>
<div class="dash-tiles py-3">
  <div class="row">
    <div class="col-xl-6">
      <div class="card border-top-0 border-bottom-0 border-right-0 border-left-lg border-blue h-100">
        <div class="card-header">Total Dealers Enrolled</div>
        <div class="card-body table-wrapper-scroll-y my-custom-scrollbar">
          <p-table [columns]="dealerEnrollmentsCountColumnDefs" [value]="dealerEnrollmentsCount" [responsive]="true"
            [globalFilterFields]="['SourceOfDealer','DealerSource','LastRODate','LastSaleDate','LastSaleFileDate','LastROFileDate','SourceType']"
            emptymessage="customMessage" class="table table-bordered" [resizableColumns]="true"  style="border:white;" [scrollable]="true" scrollHeight="150px">
            <ng-template pTemplate="header" let-columns>
              <tr>
                <th>Source Name</th>
                <th>Dealer Count</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rData let-columns="columns">
              <tr>
                <td *ngFor="let col of columns">
                  <span class="ui-g ui-fluid" >
                    {{rData[col.field]}}
                  </span>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </div>
    <div class="col-xl-6">
      <div class="card border-top-0 border-bottom-0 border-right-0 border-left-lg border-success h-100 ">
        <div class="card-header">Total Active Subscriptions</div>
        <div class="card-body">
          <p-table [columns]="subscriptionCountColumnDefs" [value]="subscriptionCount" [responsive]="true"
            class="table table-bordered" [resizableColumns]="true" style="border:white;" [scrollable]="true" scrollHeight="140px">
            <ng-template pTemplate="header" let-columns>
              <tr>
                <th *ngFor="let col of columns" [pSortableColumn]="col.field">
                  {{col.headerName}}
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rData let-columns="columns">
              <tr>
                <td *ngFor="let col of columns">
                  <span class="ui-g ui-fluid" >
                    {{rData[col.field]}}
                  </span>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="subMsg" *ngIf="subMsg != ''">
              <tr>
                <td [attr.colspan]="columns.length">
                  No records found 
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </div>
    <div class="col-xl-6 dash-margin">
      <div class="card border-top-0 border-bottom-0 border-right-0 border-left-lg border-warning h-100">
        <div class="card-header">Total Data Processed</div>
        <div class="card-body">
          <p-table [value]="totalDataProcessed" class="table table-bordered" style="border:white;" sortField="representative.name"  [scrollable]="true" scrollHeight="140px" sortMode="single">
            <ng-template pTemplate="header">
                <tr>
                    <th>Source Name</th>
                    <th>File Type Name</th>
                    <th>Received Count</th>
                    <th>Processed Count</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-totalDataProcesse let-rowIndex="rowIndex">
                <tr>
                    <td *ngIf="rowGroupMetadata[totalDataProcesse.SourceName].index === rowIndex" [attr.rowspan]="rowGroupMetadata[totalDataProcesse.SourceName].size">
                        <span class="p-text-bold p-ml-2">{{totalDataProcesse.SourceName}}</span>
                    </td>
                    <td>
                        {{totalDataProcesse.FileTypeName}}
                    </td>
                    <td>
                      {{totalDataProcesse.ReceivedRecordCount}}
                    </td>
                    <td>
                        {{totalDataProcesse.ProcessedRecordCount}}
                    </td>
                </tr>
            </ng-template>
        </p-table>
        </div>
      </div>
    </div>
    <div class="col-xl-6 dash-margin">
      <div class="card border-top-0 border-bottom-0 border-right-0 border-left-lg border-danger h-100">
        <div class="card-header">Total No. Of Issues</div>
        <div class="card-body">
          <p-table [columns]="totalNoOfIssuesCountColumnDefs" [value]="totalNoOfIssues" [responsive]="true"
            [globalFilterFields]="['SourceOfDealer','DealerSource','LastRODate','LastSaleDate','LastSaleFileDate','LastROFileDate','SourceType']"
            emptymessage="customMessage" class="table table-bordered" [resizableColumns]="true"  style="border:white;" [scrollable]="true" scrollHeight="150px">
            <ng-template pTemplate="header" let-columns>
              <tr>
                <th>Status</th>
                <th>Count</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rData let-columns="columns">
              <tr>
                <td>
                  <span class="ui-g ui-fluid">
                    <span class='badge badge-danger mr-2' >Error</span>
                  </span>
                </td>
                <td>
                  2
                </td>
                <!-- <td *ngFor="let col of columns">
                  <span class="ui-g ui-fluid" *ngIf="rData[col.field] == 'Error'" >
                    <span class='badge badge-danger mr-2' >{{rData[col.field]}}</span>
                  </span>
                  <span class="ui-g ui-fluid" *ngIf="rData[col.field] != 'Error'" >
                    {{rData[col.field]}}
                  </span>
                </td> -->
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </div>
  </div>

</div>
